import { FC, useState } from "react";
import { CheckOutlined } from "@ant-design/icons";
import {Typography, Tooltip } from "antd";
import { CopyIcon } from "../icons/CopyIcon";
import { Wrapper } from "./styled";

interface ICopyableTextPRops {
  text: string;
}

export const CopyableText: FC<ICopyableTextPRops> = ({ text }) => {
  const [isCopied, setCopied] = useState(false);

  const copyText = () => {
    setCopied(true);
    navigator.clipboard.writeText(text);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <Wrapper data-testid="copyable-text">
      <Typography.Text className="text">{text}</Typography.Text>

      {isCopied ? (
        <Tooltip overlay="Скопировано">
          <CheckOutlined />
        </Tooltip>
      ) : (
        <Tooltip overlay="Копировать">
          <button
              style={{ cursor: "pointer", border: "none", background: "unset" }}
              onClick={copyText}
            >
              <CopyIcon />
            </button> 
        </Tooltip>
      )}
    </Wrapper>
  );
};
